module.exports = __webpack_public_path__ + "static/media/jackpots-lvl1.77918366.png";